import React, { Component, Fragment } from 'react';
import { Row, Button } from 'reactstrap';
import ReactTable from 'react-table';
import { Colxx } from '../../../../components/common/CustomBootstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import DataTablePagination from '../../../../components/DatatablePagination';
import { Card, CardBody, CardTitle } from 'reactstrap';
import {
  getUserList,
  getRoleList,
  getPropertyList,
} from '../../../../redux/actions';
import {
  gAPI_Users_list,
  gAPI_Internal_Property_By_Id,
  postAPI_TrackEvent,
} from '../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../helpers/AxiosAPI';
import CreateInviteUsersForm from './components/forms/CreateInviteUsersForm';
import UpdateUsersForm from './components/forms/UpdateUsersForm';
import ReinviteUserForm from './components/forms/ReinviteUserForm';
import GenerateInvitationLink from './components/forms/GenerateInvitationLink';
import GenerateResetPasswordLink from './components/forms/GenerateResetPasswordLink';
import ContactsForm from './components/forms/ContactsForm';
const dataTableColumns = [
  {
    Header: 'Name',
    accessor: 'fullName',
    Cell: (props) => <p className="">{props.value}</p>,
  },
  {
    Header: 'Email',
    accessor: 'email',
    Cell: (props) => <p className="">{props.value}</p>,
  },
  {
    Header: 'Status',
    accessor: 'status',
    Cell: (props) => <p className="">{props.value}</p>,
  },
  {
    Header: 'Role',
    accessor: 'roles',
    Cell: (props) => (
      <p className="">
        {props.value.map((role, index) => {
          return (
            <Fragment key={index}>
              {role}
              {<br />}
            </Fragment>
          );
        })}
      </p>
    ),
  },
  {
    Header: '',
    accessor: 'userId',
    Cell: (props) => <UpdateUsersForm id={props.value} />,
  },
  {
    Header: '',
    accessor: 'email',
    Cell: (props) => (
      <p className="">
        {props.row.status !== 'Pending' ? (
          <GenerateResetPasswordLink email={props.value} />
        ) : null}
      </p>
    ),
  },
  {
    Header: '',
    accessor: 'userId',
    Cell: (props) => (
      <p className="">
        {props.row.status === 'Pending' ? (
          <ReinviteUserForm id={props.value} />
        ) : null}
      </p>
    ),
  },
  {
    Header: '',
    accessor: 'userId',
    Cell: (props) => (
      <p className="">
        {props.row.status === 'Pending' ? (
          <GenerateInvitationLink id={props.value} />
        ) : null}
      </p>
    ),
  },
];

class AdminPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: null,
      isLoading: true,
      contacts: null,
      editContact: false,
      name: '',
    };
  }

  componentDidMount() {
    // this.props.getUserList();
    if (this.props.email !== '') {
      AxiosAPI({
        method: 'post',
        url: `${postAPI_TrackEvent}`,
        data: {
          eventName: 'aiva Users and Admin',
          email: this.props.email,
        },
      }).then(
        (res) => {},
        (error) => {
          console.log(error);
        }
      );
    }
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Users_list}/${getGroupID()}`,
    }).then(
      (res) => {
        this.setState((state) => ({
          data: res.data,
          isLoading: false,
        }));
      },
      (error) => {
        this.setState({ loading: false, error, isLoading: false });
      }
    );
    if (this.props.propertyId !== '-1') {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Internal_Property_By_Id}/${
          this.props.propertyId
        }?group_id=${getGroupID()}`,
      })
        .then((res) => {
          this.setState({ contacts: res.data.contacts, name: res.data.name });
        })
        .catch((err) => console.error(err));
    }
    // this.props.getRoleList();
    // this.props.getPropertyList();
  }

  render() {
    return (
      <Fragment>
        <Row>
          {this.props.propertyId !== '-1' && (
            <Colxx xxs="6" className="mb-2">
              <Button
                color="primary"
                outline
                size="lg"
                onClick={() => this.setState({ editContact: true })}
                style={{ width: '100%', borderRadius: '6px' }}
              >
                + Subscribe to Tickets & Emails
              </Button>
              {this.state.editContact && (
                <ContactsForm
                  contacts={this.state.contacts}
                  id={this.props.propertyId}
                  name={this.state.name}
                  visible={this.state.editContact}
                  toggle={() =>
                    this.setState({
                      editContact: !this.state.editContact,
                    })
                  }
                />
              )}
            </Colxx>
          )}

          <Colxx xxs="6" className="mb-2">
            <CreateInviteUsersForm />
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-2">
            <Fragment>
              <CardTitle>Users</CardTitle>
              <Card className="mb-2">
                <CardBody>
                  {!this.state.isLoading && this.state.data ? (
                    <ReactTable
                      data={this.state.data}
                      columns={dataTableColumns}
                      defaultPageSize={10}
                      filterable={false}
                      showPageJump={true}
                      PaginationComponent={DataTablePagination}
                      showPageSizeOptions={true}
                    />
                  ) : (
                    <div className="loading" />
                  )}
                </CardBody>
              </Card>
            </Fragment>
          </Colxx>

          {/* <Colxx xxs="4" className="mb-2">
            <CardTitle>Permissions</CardTitle>
            <Card className="mb-2">
              <CardBody>
                {loading1 ? (
                  <Fragment>
                    <div className="d-flex ticket-info-requester-title">
                      Roles
        </div>
                    {roles.map((role, index) => {
                      return (
                        <CustomInput
                          key={index}
                          type="checkbox"
                          id="exCustomInline"
                          label={role.name}
                        />
                      );
                    })}
                  </Fragment>
                ) : (
                    <div className="loading" />
                  )}
                {loading2 ? (
                  <Fragment>
                    <div className="d-flex ticket-info-requester-title">
                      Properties
        </div>
                    {properties.map((property, index) => {
                      return (
                        <CustomInput
                          key={index}
                          type="checkbox"
                          id="exCustomInline"
                          label={property.name}
                        />
                      );
                    })}
                  </Fragment>
                ) : (
                    <div className="loading" />
                  )}
              </CardBody>
            </Card>
          </Colxx> */}
        </Row>
      </Fragment>
    );
  }
}
const mapStateToProps = ({ usersListApp, settings }) => {
  const { propertyId, email } = settings;
  return {
    usersListApp,
    propertyId,
    email,
  };
};
export default injectIntl(
  connect(mapStateToProps, {
    getUserList,
    getRoleList,
    getPropertyList,
  })(AdminPage)
);
